// Generated from SVG to Code Figma Plugin

import type { JSX } from 'react';

export const BaseLineAudioPlay = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M5.51562 4.125C5.8335 3.94903 6.22215 3.95977 6.53027 4.15234L18.5303 11.6523C18.8224 11.8351 19 12.1553 19 12.5C19 12.8447 18.8224 13.1649 18.5303 13.3477L6.53027 20.8477C6.22215 21.0402 5.8335 21.051 5.51562 20.875C5.19767 20.6988 5 20.3635 5 20V5L5.00879 4.86523C5.0509 4.55519 5.23741 4.2792 5.51562 4.125Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);
